import { DataTable, Heading, Loader } from "@/components"
import useViewDetails from "./useViewJobDetails";

const ViewJobDetails = () => {
  const {columns, title, breadcrumbData, isLoadingJobSimulate,
    simulateDetails} = useViewDetails();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={title} breadcrumbData={breadcrumbData} />
        </div>
        <div className="flex flex-row gap-3 items-center">
          <span className="text-[20px] font-semibold text-primary">Plan</span>
        </div>
      </div>

      {isLoadingJobSimulate ? 
        <Loader /> : 
        <DataTable data={simulateDetails} columns={columns} hideFooter />
      }
    </div>
  )
}

export default ViewJobDetails;